export default __webpack_public_path__ + "static/media/cushions.5dcad69f.svg";